import React, { useState, useEffect } from 'react';
import './BrainTransition.css';

// ═══════════════════════════════════════════════════════════════
// BRAIN TRANSITION - Enhanced Visual Experience
// Quick Pulse + Trait Hint with all polish features
// ═══════════════════════════════════════════════════════════════

// Trait hints based on brain dominance
const LEFT_BRAIN_TRAITS = [
    { emoji: '📊', trait: 'Analytical Mind' },
    { emoji: '🔢', trait: 'Logical Thinker' },
    { emoji: '📋', trait: 'Detail-Oriented' },
    { emoji: '🎯', trait: 'Precision Focus' },
    { emoji: '🧮', trait: 'Pattern Seeker' },
    { emoji: '📐', trait: 'Structured Mind' },
];

const RIGHT_BRAIN_TRAITS = [
    { emoji: '🎨', trait: 'Creative Spirit' },
    { emoji: '💡', trait: 'Big Picture Vision' },
    { emoji: '🌈', trait: 'Intuitive Sense' },
    { emoji: '✨', trait: 'Imaginative Flow' },
    { emoji: '🎭', trait: 'Expressive Nature' },
    { emoji: '🌟', trait: 'Abstract Thinker' },
];

export const BrainTransition = ({
    phrase = "Nice!",
    dominanceType = null,
    questionNumber = 0,
    totalQuestions = 10
}) => {
    const [showContent, setShowContent] = useState(false);
    const [trait, setTrait] = useState(null);

    // Pick a random trait based on dominance type
    useEffect(() => {
        const traits = (dominanceType === 'right_brain' || dominanceType === 'right-brain') ? RIGHT_BRAIN_TRAITS : LEFT_BRAIN_TRAITS;
        const randomTrait = traits[Math.floor(Math.random() * traits.length)];
        setTrait(randomTrait);

        // Trigger animation after mount
        const timer = setTimeout(() => setShowContent(true), 50);
        return () => clearTimeout(timer);
    }, [dominanceType]);

    if (!trait) return null;

    return (
        <div className="brain-transition">
            {/* Background glow for depth */}
            <div className={`bg-glow ${showContent ? 'active' : ''}`} />

            {/* Sparkle particles */}
            <div className="sparkles">
                <div className={`sparkle sparkle-1 ${showContent ? 'active' : ''}`}>✦</div>
                <div className={`sparkle sparkle-2 ${showContent ? 'active' : ''}`}>✧</div>
                <div className={`sparkle sparkle-3 ${showContent ? 'active' : ''}`}>✦</div>
            </div>

            {/* Progress counter */}
            <div className={`progress-counter ${showContent ? 'active' : ''}`}>
                <span className="current">{questionNumber}</span>
                <span className="separator">/</span>
                <span className="total">{totalQuestions}</span>
            </div>

            {/* Enhanced checkmark with glow */}
            <div className={`pulse-container ${showContent ? 'active' : ''}`}>
                {/* Glow ring */}
                <div className="glow-ring" />
                <div className="glow-ring glow-ring-2" />

                {/* Center Circle */}
                <div className="pulse-center">
                    {/* Animated checkmark */}
                    <svg viewBox="0 0 24 24" className="checkmark">
                        <path
                            className="checkmark-path"
                            d="M9 16.17L4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41z"
                        />
                    </svg>
                </div>
            </div>

            {/* Trait Pill with gradient border */}
            <div className={`trait-hint ${showContent ? 'active' : ''}`}>
                <div className="trait-inner">
                    <span className="trait-emoji">{trait.emoji}</span>
                    <span className="trait-text">{trait.trait}</span>
                </div>
                {/* Shimmer effect */}
                <div className="shimmer" />
            </div>
        </div>
    );
};
